import { formatMoney, formatRate } from '../../utils/formatOpportunityValues';
export const crossSellEvidenceLines = (evidence, texts, locale)=>{
    const peerLines = [
        texts.peerAdoption({
            rate: formatRate(evidence.peerAdoptionRate, locale),
            template: evidence.templateName
        }),
        texts.peerClientCount({
            count: evidence.peerClientCount
        })
    ];
    const avgTemplateAmount = evidence.avgTemplateAmount;
    return avgTemplateAmount == null ? peerLines : [
        ...peerLines,
        texts.avgTemplateAmount({
            amount: formatMoney(avgTemplateAmount, locale)
        })
    ];
};
